import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';
import { transferOrderGridProperties } from '../../data/transfer-order-properties';
import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import type { GridColumn } from './types';

const name = <FormattedMessage {...messages.expectedDeliveryDateColumnHeader} />;

export const expectedDeliveryDateColumn: GridColumn = {
  name,
  render: (data) => {
    const { expectedDeliveryDate } = data;
    if (!expectedDeliveryDate) return null;
    return <UserDateTimezoneFormat dateTime={expectedDeliveryDate as string} />;
  },
  id: transferOrderGridProperties.expectedDeliveryDate,
};
